import React from 'react';

const StatCard = ({ title, value, icon: Icon, colorClass }) => (
    <div className="bg-white p-4 sm:p-5 rounded-xl shadow-sm border border-slate-100 flex items-start gap-3 min-w-0 overflow-hidden">
        <div className={`p-2.5 rounded-lg ${colorClass} text-white flex-shrink-0`}>
            <Icon size={20} />
        </div>
        <div className="min-w-0 flex-1">
            <p className="text-slate-500 text-xs sm:text-sm font-medium leading-snug line-clamp-2">{title}</p>
            <h3 className="mt-1 text-lg sm:text-xl font-bold text-slate-800 tabular-nums tracking-tight break-all">
                {value}
            </h3>
        </div>
    </div>
);

export default StatCard;
